// Chakra Imports
import {
    Box,
    Button,
    Flex,
    Grid,
    Icon,
    Spacer,
    Text,
    Switch,
    ButtonGroup,
    FormControl,
    RadioGroup,
    FormLabel,
    IconButton,
    Input,
    Link,
    useColorMode,
    useColorModeValue,
    useDisclosure,
    Modal,
    ModalBody,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalFooter,
    Radio,
    FormHelperText,
    HStack,
    Select

} from "@chakra-ui/react";
import IconBox from "components/Icons/IconBox";
import PuffLoader from "react-spinners/PuffLoader";
import React, { useState, useEffect } from "react";
import { HSeparator } from "components/Separator/Separator";
import { RiPlantLine } from "react-icons/ri";
import allpopup from "api/popup/all-popup";

import ReactSelect from 'react-select/creatable'
import { useHistory, useLocation } from "react-router-dom";
export default function SubMenu(props) {
    const { data, setSubMenuData, ...rest } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [options, setOptions] = useState(false);
    const history = useHistory();
    useEffect(() => {
        setIsLoading(true)
        allpopup(data.address).then((result) => {
            let items = []
            result.data.map((item) => {
                items.push({ value: "#" + item._id, label: item.title })

            })
            items.push({ value: "new", label: "-- ساخت پاپ‌آپ جدید --" })
            setOptions(items)
        }).catch((err) => {
            console.error(err)
            if (err?.response?.data?.message?.pr)
                return toast.error(err?.response?.data?.message?.pr, {
                    position: "bottom-right"
                })
            else
                return toast.error("خطایی رخ داده است.", {
                    position: "bottom-right"
                })
        }).finally(() => {
            setIsLoading(false)
        })
    }, [])

    const iconBlue = useColorModeValue("gray.100", "gray.600");
    const textColor = useColorModeValue("gray.700", "white");

    const border = useColorModeValue("#E2E8F0", " rgba(255, 255, 255, 0.24)");

    const { colorMode } = useColorMode();
    const [inputFields, setInputFields] = useState(data.items)

    const [titleInput, setTitleInput] = useState(data.title)
    const [reload, setReload] = useState(false)
    const handleFormChange = (index, event) => {
        let input = [...inputFields];
        if (name)
            input[index][name] = event.value;
        else
            input[index][event.target.name] = event.target.value;
        setInputFields(input);
        setSubMenuData({
            ...data,
            title: titleInput, items: input
        })
    }
    const handleSelectChange = (index, event, name) => {
        let input = [...inputFields];
        if (event.value == "new") history.push("/admin/popups");
        input[index][name] = event.value;
        setInputFields(input);
        setSubMenuData({
            ...data,
            title: titleInput, items: input
        })
    }
    const removeFields = (index) => {
        let input = [...inputFields];
        input.splice(index, 1)
        setInputFields(input);
        let t = title
        if (data.length == 0)
            t = ""
        setSubMenuData({
            ...data,
            title: t, items: input
        })
        setReload(!reload)
    }
    const addFields = () => {
        let newfield = { target: "_parent", title: "", href: '#' }
        setInputFields([...inputFields, newfield])
        setReload(!reload)
    }
    const handleTitleChange = (event) => {
        let title = event.target.value
        let items = [...inputFields];
        setTitleInput(title)
        setSubMenuData({
            ...data,
            title: title, items: items
        })
    }
    useEffect(() => {
        let items = [...inputFields];
        setSubMenuData({
            ...data,
            title: titleInput, items: items
        })
    }, [reload])
    const colourStyles = {
        control: (styles) => { return ({ ...styles, backgroundColor: iconBlue, borderColor: border, "font-size": "12px" }) },
        option: (styles, { data, isSelected }) => {
            if (data.value == "new")
                return ({ ...styles, textAlign: "center", color: "#485ea1", "font-size": "12px" })
            else if (isSelected)
                return ({ ...styles, backgroundColor: "#C3D0BF", color: "black", "font-size": "12px" })
            else
                return ({ ...styles, color: "black", "font-size": "12px" })
        },
        singleValue: (styles) => ({ ...styles, color: textColor }),
        placeholder: (styles) => ({ ...styles, color: textColor }),
        input: (styles) => ({ ...styles, color: textColor }),
    };

    return (

        (isLoading) ?
            <Grid>
                <PuffLoader
                    cssOverride={{ margin: "50px auto" }}
                    color={"gray"}
                    loading={isLoading}
                    size={100}
                    speedMultiplier={"0.5"}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                />
            </Grid>
            :
            <Grid ml={"5px"} mb={"10px"}>

                <FormControl w='100%' mb="30px" ml="5x" id="feed-title">
                    <FormLabel fontSize="xs" >عنوان کلی</FormLabel>
                    <Input fontSize="xs" placeholder="عنوان را وارد کنید." value={titleInput} onChange={e => handleTitleChange(event)} />
                </FormControl>
                <HSeparator mb={"15px"} bg={colorMode === "dark" ? "linear-gradient(90deg, rgba(224, 225, 226, 0) 0%, #303742 49.52%, rgba(224, 225, 226, 0) 100%)" : "linear-gradient(90deg, rgba(224, 225, 226, 0) 0%, #eee 49.52%, rgba(224, 225, 226, 0) 100%)"}></HSeparator>

                {options && inputFields.map((input, index) => {
                    let find = options.find((opt) => opt.value == input.href)
                    const defaultSelected = find ? find : { label: input.href, value: input.href }
                    return (
                        <div key={index} >
                            {(index != 0) ?
                                (
                                    <HSeparator mt={"35px"} bg={colorMode === "dark" ? "linear-gradient(90deg, rgba(224, 225, 226, 0) 0%, #303742 49.52%, rgba(224, 225, 226, 0) 100%)" : "linear-gradient(90deg, rgba(224, 225, 226, 0) 0%, #eee 49.52%, rgba(224, 225, 226, 0) 100%)"}></HSeparator>
                                ) : <></>
                            }
                            <Grid mt={"30px"} templateColumns={{ sm: "1fr", lg: "2fr 2fr" }} templateRows='1fr'>
                                <Flex>
                                    <FormControl w='100%' id="title">
                                        <FormLabel fontSize="xs" >عنوان {"#" + (index + 1)}</FormLabel>
                                        <Input name='title' fontSize="xs" placeholder="عنوان را وارد کنید." value={input.title} onChange={event => handleFormChange(index, event)} />
                                    </FormControl>
                                </Flex>
                                <Flex>
                                    <FormControl mr={{ sm: "0px", md: "5px" }} mt={{ sm: "20px", md: "0px" }} w='100%' id="target">
                                        <FormLabel fontSize="xs">نوع باز شدن</FormLabel>
                                        <Select dir={"ltr"} disabled={(input?.href?.startsWith("#"))} fontSize="xs" onChange={event => handleFormChange(index, event)} name="target" >
                                            <option dir={"rtl"} selected={"_parent" == input.target || "_self" == input.target || input?.href?.startsWith("#")} value="_parent">در همان صفحه</option>
                                            <option dir={"rtl"} selected={"_blank" == input.target} value="_blank">در صفحه جدید</option>
                                        </Select>
                                    </FormControl>
                                </Flex>
                            </Grid>
                            <FormControl w='100%' mt={"20px"} mb={"10px"} id="href">
                                <FormLabel fontSize="xs">آدرس {"#" + (index + 1)}</FormLabel>
                                <ReactSelect defaultValue={defaultSelected} formatCreateLabel={userInput => `ثبت آدرس اینترنتی:  ${userInput}`} onChange={event => handleSelectChange(index, event, "href")} styles={colourStyles} options={options} dir="ltr" fontSize="xs" placeholder="" />
                                <FormHelperText fontSize={"xs"}>یکی از پاپ‌آپ‌ها را انتخاب کرده، یا آدرس وب مد نظر را تایپ کنید.</FormHelperText>
                            </FormControl>
                            <Grid>
                                <Flex>
                                    <Button mt={"10px"} fontSize='xs' onClick={() => removeFields(index)} >حذف رکورد</Button>
                                </Flex>
                            </Grid>
                        </div>
                    )
                })}
                <Grid textAlign={"center"}>
                    <Button onClick={addFields} mt={"30px"} mr="auto" ml="auto" fontSize='xs' >افزودن زیر منوی جدید</Button>
                </Grid>
            </Grid>

    );
}
